module.exports = __webpack_public_path__ + "img/auto_spin_btn.8df1a021.png";